var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBarcode01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.6 139.854 16 16",
    enableBackground: "new 78.6 139.854 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M81.6,151.854v-8h-1v8H81.6z M82.6,151.854h3v-8h-3V151.854z M86.6,151.854h1v-8h-1V151.854z M90.6,143.854 h-2v8h2V143.854z M91.6,143.854v8h1v-8H91.6z M79.6,151.854h-1v4h4v-1h-3V151.854z M79.6,140.854h3v-1h-4v4h1V140.854z  M90.6,139.854v1h3v3h1v-4H90.6z M93.6,154.854h-3v1h4v-4h-1V154.854z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcode01);
export default __webpack_public_path__ + "static/media/icon_barcode-01.9b82bf8d5dce540f8b5fcc78e74ae614.svg";
export { ForwardRef as ReactComponent };